import "@fontsource-variable/roboto";
import "@/styles/globals.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "@/App";
import { installStaleChunkRecovery } from "@/lib/stale-chunk-recovery";
import { applyMotionPreference } from "@/lib/motion";

installStaleChunkRecovery();
applyMotionPreference();

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container missing in index.html");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
